import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { connect } from "react-redux";
import {
    Paper,
    Typography,
    Button,
    Grid,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Input,
    IconButton,
    InputAdornment,
    Avatar
} from "@material-ui/core";
import AddPersonIcon from "@material-ui/icons/PersonAdd";
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner
} from "reactstrap";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import AddPhotoIcon from "@material-ui/icons/AddAPhoto";
import { noImg } from "vrcore-dashboard/dist/utilities";
import { setNewUser, getQualifications } from "./actions";
import moment from "moment";
import styled from "styled-components";
import defaultProfile from "./defaultProfile";

import { MaxImageSizeSnackbar, AddUserSnackbar } from "./Snackbars";
const StyledAvatar = styled(Avatar)`
    height: 200px !important;
    width: 200px !important;
    margin: auto !important;
    border: 1px solid black !important;
`;
class AddUserWidget extends Component {
    constructor(props) {
        super(props);
        let user;
        if (props.userProfileKeys) {
            user = this.defineUserProfile(props.userProfileKeys);
        } else {
            user = defaultProfile;
        }
        this.state = {
            addUserModal: false,
            showPassword: false,
            password: "",
            user: user,
            canSubmit: false,
            uploadImageLocal: false,
            imageMaxSize: false,
            newUserSuccess: false,
            newUserFail: false,
            addingUser: false
        };
        props.getQualifications();
    }
    defineUserProfile = keys => {
        let user = {
            first_name: "",
            last_name: "",
            email: "",
            profile_image_url: "",

            agreed_to_eula: "No",
            agreed_to_eula_timestamp: "",

            account_created: "",
            last_active: "",

            access_level: "Level 4",
            security_level: "Admin",
            deleted: false
        };
        keys.map(key_info => {
            user[key_info.key] = key_info.default;
            return true;
        });
        return user;
    };
    handleUserReset = () => {
        let user;
        if (this.props.userProfileKeys) {
            user = this.defineUserProfile(this.props.userProfileKeys);
        } else {
            user = defaultProfile;
        }
        this.setState({
            password: "",
            canSubmit: false,
            uploadImageLocal: false,
            imageMaxSize: false,
            user: user
        });
    };
    renderTextDetail = (key, label) => {
        const { user } = this.state;
        return (
            <TextField
                value={user[key]}
                label={label}
                onChange={event => {
                    let user = {
                        ...this.state.user,
                        [key]: event.target.value
                    };
                    this.canSubmit();
                    this.setState({ user });
                }}
            />
        );
    };
    renderDropdown = (key, label, opts) => {
        const { user } = this.state;

        return (
            <FormControl style={{ width: "80%" }}>
                <InputLabel>{label}</InputLabel>
                <Select
                    value={user[key]}
                    onChange={event => {
                        let user = {
                            ...this.state.user,
                            [key]: event.target.value
                        };
                        this.setState({ user });
                        this.canSubmit();
                    }}
                >
                    {opts.map(e => {
                        return (
                            <MenuItem value={e} key={e}>
                                {e}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        );
    };
    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    canSubmit() {
        if (
            this.state.password.length >= 5 &&
            this.validateEmail(this.state.user.email)
        )
            this.setState({ canSubmit: true });
        else this.setState({ canSubmit: false });
    }
    renderRequiredUserDetails = () => {
        return (
            <Grid container spacing={8}>
                <Grid item md={6} xs={12}>
                    {this.renderTextDetail("first_name", "First Name")}
                    {this.renderTextDetail("last_name", "Last Name")}

                    <div>
                        {this.renderDropdown("access_level", "Access Level", [
                            "Level 0",
                            "Level 1",
                            "Level 2",
                            "Level 3",
                            "Level 4"
                        ])}
                    </div>

                    <div>
                        {this.renderDropdown(
                            "security_level",
                            "Security Level",
                            ["User", "Admin"]
                        )}
                    </div>
                    {this.renderTextDetail("email", "Email Address")}
                    <FormControl>
                        <InputLabel htmlFor="adornment-password">
                            Password
                        </InputLabel>
                        <Input
                            autoComplete="off"
                            id="adornment-password"
                            type={this.state.showPassword ? "text" : "password"}
                            value={this.state.password}
                            onChange={event => {
                                this.setState({ password: event.target.value });
                                this.canSubmit();
                            }}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Toggle password visibility"
                                        onClick={() => {
                                            this.setState({
                                                showPassword: !this.state
                                                    .showPassword
                                            });
                                        }}
                                    >
                                        {this.state.showPassword ? (
                                            <Visibility />
                                        ) : (
                                            <VisibilityOff />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                </Grid>
                <Grid item md={6} xs={12}>
                    <StyledAvatar
                        style={{}}
                        src={
                            this.state.uploadImageLocal
                                ? this.state.uploadImageLocal
                                : noImg
                        }
                        alt="Profile Image"
                    />
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: 33
                        }}
                    >
                        <input
                            type="file"
                            id="file"
                            ref="imageUploader"
                            accept="image/jpeg, image/png"
                            style={{ display: "none" }}
                            onChange={event => {
                                if (event.target.files[0].size > 1000000) {
                                    this.setState({
                                        imageMaxSize: true
                                    });
                                } else {
                                    let user = {
                                        ...this.state.user,
                                        profile_image_url: event.target.files[0]
                                    };

                                    this.setState({
                                        user,
                                        uploadImageLocal: URL.createObjectURL(
                                            event.target.files[0]
                                        )
                                    });
                                }
                            }}
                        />
                        <IconButton
                            style={{
                                color: "indigo",
                                border: "1px solid indigo",
                                margin: "auto"
                            }}
                            onClick={() => {
                                this.refs.imageUploader.click();
                            }}
                        >
                            <AddPhotoIcon />
                        </IconButton>
                        <Typography style={{ margin: "auto" }} variant="body1">
                            Add Profile Picture {`(<1MB)`}
                        </Typography>
                    </div>
                </Grid>
            </Grid>
        );
    };
    renderSecondaryUserDetails = () => {
        if (this.props.userProfileKeys) {
            return (
                <Grid container spacing={8}>
                    {this.props.userProfileKeys.map(key_info => {
                        switch (key_info.type) {
                            case "text":
                                return (
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                        key={key_info.key}
                                    >
                                        {this.renderTextDetail(
                                            key_info.key,
                                            key_info.label
                                        )}
                                    </Grid>
                                );
                            case "dropdown":
                                return (
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                        key={key_info.key}
                                    >
                                        {this.renderDropdown(
                                            key_info.key,
                                            key_info.label,
                                            key_info.opts
                                        )}
                                    </Grid>
                                );
                            default:
                                return null;
                        }
                    })}
                </Grid>
            );
        } else {
            return (
                <Grid container spacing={8}>
                    <Grid item md={6} xs={12}>
                        {this.renderTextDetail("contact_no", "Contact No.")}
                    </Grid>
                    <Grid item md={6} xs={12}>
                        {this.renderTextDetail("address", "Address")}
                    </Grid>
                </Grid>
            );
        }
    };
    handleUserSubmit = () => {
        const { qualifications } = this.props;
        const { user, password } = this.state;
        let date = moment().format("DD-MM-YYYY HH:mm:ss");
        user.account_created = date;
        user.last_active = date;
        let quals = {};
        if (qualifications) {
            Object.keys(qualifications).map(e => {
                quals[e] = {
                    qualification_category:
                        qualifications[e].qualification_category,
                    qualification_desc: qualifications[e].qualification_desc,
                    qualification_exp_date: "Req.",
                    qualification_id: qualifications[e].qualification_id,
                    qualification_img: "",
                    qualification_img_2: "",
                    qualification_invalid_img:
                        qualifications[e].qualification_invalid_img,
                    qualification_prefix:
                        qualifications[e].qualification_prefix,
                    qualification_reg_num: "",
                    qualification_title: qualifications[e].qualification_title,
                    qualification_valid_img:
                        qualifications[e].qualification_valid_img,
                    qualification_verified: "No"
                };
                return true;
            });
        }
        user.qualifications_per_user = quals;
        this.props.setNewUser(user, password, success => {
            if (success === "addingUser") {
                this.setState({ addingUser: true });
            } else if (success === true) {
                this.setState({ addingUser: false, newUserSuccess: true });
            } else if (success === false) {
                this.setState({ addingUser: false, newUserFail: true });
            }
        });

        this.setState({ addUserModal: false });
        this.handleUserReset();
    };
    render() {
        return (
            <React.Fragment>
                <Paper
                    style={{
                        width: "fit-content",
                        border: "1px solid black",
                        marginTop: 20,
                        marginBottom: 20,
                        padding: 20,
                        textAlign: "center"
                    }}
                >
                    <Typography variant="title">
                        <b>User Manager</b>
                    </Typography>

                    <Button
                        color="primary"
                        variant="contained"
                        style={{
                            border: "1px solid black",
                            opacity: 0.8,
                            marginTop: 30
                        }}
                        onClick={() => {
                            this.handleUserReset();
                            this.setState({ addUserModal: true });
                        }}
                    >
                        <AddPersonIcon />
                        <Typography
                            style={{ marginLeft: 15, color: "white" }}
                            variant="title"
                        >
                            Add New User
                        </Typography>
                    </Button>
                </Paper>
                <Modal isOpen={this.state.addUserModal}>
                    <ModalHeader>Add New User Details</ModalHeader>
                    <ModalBody>
                        {!this.state.addingUser && (
                            <>
                                <Typography
                                    style={{
                                        width: "fit-content",
                                        margin: "auto",
                                        marginBottom: 15
                                    }}
                                    variant="headline"
                                >
                                    User Details
                                </Typography>
                                {this.renderRequiredUserDetails()}
                                {this.renderSecondaryUserDetails()}
                            </>
                        )}
                        {this.state.addingUser && (
                            <div style={{ width: 200, margin: "auto" }}>
                                <Spinner
                                    style={{
                                        height: 100,
                                        width: 100,
                                        marginRight: "25%",
                                        marginLeft: "25%"
                                    }}
                                    color="primary"
                                />
                                <Typography
                                    style={{
                                        textAlign: "center",
                                        marginTop: 15
                                    }}
                                    variant="body2"
                                >
                                    Adding User, This Will Take a Moment
                                </Typography>
                            </div>
                        )}
                    </ModalBody>
                    {!this.state.addingUser && (
                        <ModalFooter>
                            <Button
                                onClick={() => {
                                    this.handleUserReset();
                                    this.setState({ canSubmit: false });
                                }}
                            >
                                Reset
                            </Button>
                            <Button
                                onClick={() => {
                                    this.handleUserReset();
                                    this.setState({
                                        addUserModal: false,
                                        canSubmit: false
                                    });
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={!this.state.canSubmit}
                                onClick={() => {
                                    this.setState({ addingUser: true });
                                    this.handleUserSubmit();
                                }}
                                variant="contained"
                                color="primary"
                            >
                                Submit
                            </Button>
                        </ModalFooter>
                    )}
                </Modal>
                <MaxImageSizeSnackbar
                    modalState={this.state.imageMaxSize}
                    setModalState={() => this.setState({ imageMaxSize: false })}
                />
                <AddUserSnackbar
                    newUserFail={this.state.newUserFail}
                    newUserSuccess={this.state.newUserSuccess}
                    setModalState={() =>
                        this.setState({
                            newUserFail: false,
                            newUserSuccess: false
                        })
                    }
                />
            </React.Fragment>
        );
    }
}
export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const { selectQualifications } = selectors;
            return { qualifications: selectQualifications(store) };
        },
        { setNewUser, getQualifications }
    )(AddUserWidget)
);
